import { render, staticRenderFns } from "./MailTemplateLayout.vue?vue&type=template&id=3bab53c4&scoped=true"
import script from "./MailTemplateLayout.vue?vue&type=script&lang=js"
export * from "./MailTemplateLayout.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateLayout.vue?vue&type=style&index=0&id=3bab53c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab53c4",
  null
  
)

export default component.exports